export default __webpack_public_path__ + "acfc6cbf3fa63522b15213547edb934d.png";